// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_gU","advertCardFooter__row":"c-a_gV","advertCardFooter__name":"c-a_gW","advertCardFooter__price":"c-a_gX","advertCardFooter__age":"c-a_gY"};